export const utilityPhonesPath = "/devices/utilities"
export const createUtilityPhonesPath = "/devices/utilities/new"
export const bulkActivationPath = "/devices/bulk-activation"
export const registerPhonesPath = "/devices/register-phones"
export const purchaseDevicesPath = "/devices/purchase-devices"

export const buildUtilityPhoneEditPath = phoneId => `/devices/utilities/${phoneId}/edit`
